import { TranslateFn } from '@blocs.i18n';
import { FeedbackPickFragment } from '@minecraft.graphql-operations';

type PickObject = Omit<FeedbackPickFragment, '__typename' | 'created'>;
export const getMyPickByName = ({ userName, pickedBy }: { userName: string; pickedBy?: PickObject[] }) =>
  (pickedBy || []).find((pick) => pick.userName === userName) || {};

export const getPickTooltipContent = (
  { myPick, pickedBy }: { myPick: PickObject; pickedBy?: PickObject[] },
  t: TranslateFn
): string => {
  return pickedBy
    ?.reduce((accum, pick) => {
      if (!pick?.userName) {
        return accum;
      }

      if (pick?.id === myPick?.id) {
        const myPickUsername = t('common:pick.tooltip.you', { userName: pick.userName });
        return [myPickUsername, ...accum];
      }

      return [...accum, pick.userName];
    }, [])
    .join(', ');
};
